<!--
 * @Description: table&detail
 * @Date: 2019-11-05 19:51:36
 -->
<template>
  <div class="table-box">
    <!-- 列表 -->
    <div v-show="!showBox">
      <!-- 一级tab -->
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
        v-if="content.length > 1"
      >
        <el-tab-pane
          :label="v.name"
          :name="v.name"
          isDisabled
          v-for="(v, k) in content"
          :key="k"
        />
      </el-tabs>
      <!-- 二级tab -->
      <el-radio-group
        v-model="childActiveIndex"
        @change="handleChildClick"
        v-if="content[activeIndex].childMenu.length > 1"
        style="margin-top:10px;margin-bottom: 25px;display:block;text-align:left;"
      >
        <el-radio-button
          :label="k"
          :name="v.name || ''"
          v-for="(v, k) in content[activeIndex].childMenu"
          :key="k"
        >
          {{ v.name || '' }}
        </el-radio-button>
      </el-radio-group>
      <slot
        name="search"
        v-bind="{
          handleSearch: handleSearch,
          searchItem: searchItem,
          beforeSearch: beforeSearch,
          moreBtnArr: moreBtnArr,
          showClearAll: showClearAll,
          defaultQuery: defaultQuery,
          query: test
        }"
      >
        <template v-show="!fromJump">
          <component
            v-if="searchComponent && searchComponent !== 'lSearch'"
            ref="search"
            @search="handleSearch"
            @beforeSearch="handBeforeSearch"
            :is="searchComponent"
            :searchItem="searchItem"
            :beforeSearch="beforeSearch"
            :moreBtnArr="moreBtnArr"
            :showClearAll="showClearAll"
            :query="test"
            :defaultQuery="defaultQuery"
          />
        </template>
      </slot>
      <!-- 提示信息 start -->
      <slot
        name="top-alert"
        v-bind="{ activeIndex, selection, tableResp, childActiveIndex }"
      ></slot>
      <!-- 提示信息 ended -->
      <!--列表-->
      <el-table
        style="width: 100%;border-left:1px solid #EBEEF5;"
        border
        ref="table"
        :size="$attrs.size"
        :data="tableData"
        :empty-text="tips"
        :stripe="true"
        :highlight-current-row="false"
        :row-class-name="({ row, rowIndex }) => rowClassName({ row, rowIndex })"
        :height="$attrs.height || undefined"
        :row-key="$attrs.rowKey"
        :span-method="$attrs.spanMethod"
        :beforeSelectAll="$attrs.beforeSelectAll"
        @cell-click="cellClick"
        v-loading="loading"
        v-on="$listeners"
      >
        <template
          v-for="(v, k) in content[activeIndex].childMenu[childActiveIndex]
            .fields"
        >
          <el-table-column
            v-if="v.type === 'expand'"
            type="expand"
            :key="k - 4"
            :label="v.label"
          >
            <template slot-scope="{ row, column, $index }">
              <template v-if="v.render">
                <myrender
                  :row="row"
                  :column="column"
                  :index="k"
                  :no="$index"
                  :render="v.render || null"
                />
              </template>
              <template v-else>
                <tableForm :data="{ row, column: v }" />
              </template>
            </template>
          </el-table-column>
          <el-table-column
            :key="k - 1"
            v-else-if="v.type === 'expandOrder'"
            type="expand"
          >
            <template slot-scope="{ row }">
              <tableFormOrder :data="{ row, column: v }" />
            </template>
          </el-table-column>
          <el-table-column
            :key="k - 2"
            v-else-if="v.type === 'index'"
            type="index"
            align="center"
            label="序号"
            :width="v.width || ''"
          />
          <template v-else-if="v.type === 'selection'">
            <el-table-column
              v-if="v.visible !== false"
              :reserve-selection="v.reserve"
              type="selection"
              :prop="$attrs.rowKey"
              :index="k"
              :width="v.width || '40px'"
              :selectable="
                v.selectable ||
                  function() {
                    return true;
                  }
              "
              :key="k - 3 - childActiveIndex + activeIndex"
            ></el-table-column>
          </template>
          <el-table-column
            v-else-if="v.type === 'customCheck'"
            :width="v.width || ''"
            :render-header="h => v.renderHeader(h, tableData)"
            :key="k - 99"
            align="center"
          >
            <template slot-scope="scope">
              <template v-if="v.render">
                <myrender
                  :row="scope.row"
                  :column="scope.column"
                  :index="k"
                  :no="scope.$index"
                  :render="v.render || null"
                />
              </template>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :prop="v.prop"
            :label="v.label"
            :width="v.width || ''"
            :formatter="v.formatter"
            :show-overflow-tooltip="
              v.showToolTip !== undefined ? v.showToolTip : true
            "
            :key="`${k}-${v.prop}`"
            :align="v.align || 'center'"
          >
            <template #header="{column,$index}" v-if="v.headerRender">
              <template>
                <myrender
                  :row="null"
                  :column="column"
                  :index="k"
                  :no="$index"
                  :render="v.headerRender || null"
                />
              </template>
            </template>
            <template slot-scope="scope">
              <template v-if="v.render">
                <myrender
                  :row="scope.row"
                  :column="scope.column"
                  :index="k"
                  :no="scope.$index"
                  :render="v.render || null"
                />
              </template>
              <template v-else>
                <span
                  :style="v.style && v.style(scope)"
                  class="cell el-tooltip"
                >
                  {{
                    v.formatter
                      ? v.formatter(
                          scope.row,
                          scope.column,
                          scope.row[(scope.column || {}).property]
                        )
                      : scope.row[(scope.column || {}).property] || '-'
                  }}
                </span>
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <div
        v-if="propData && propData.showFooter"
        class="table-render-slot-footer"
        v-html="propData.footer"
      ></div>

      <!--批量操作start-->
      <el-row :gutter="12" type="flex" style="padding: 15px 0;flex-wrap: wrap;">
        <slot
          name="batchAction"
          v-bind="{ tableRef: $refs.table, tableResp, activeIndex }"
        ></slot>
      </el-row>
      <!--批量操作ended-->
      <el-pagination
        v-if="totalElements !== void 0 && !hidePagination"
        :small="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNo"
        :total="totalElements"
        :page-sizes="$attrs.pageSizes || [15, 60, 100]"
        :page-size="paginationData.pageSize"
        :layout="$attrs.pageLayout || 'total, sizes, prev, pager, next, jumper'"
      />
    </div>
    <div class="component-box" v-if="showBox">
      <el-button
        @click="closeDetail"
        type="text"
        class="newBackBtn"
        icon="el-icon-arrow-left"
      >
        返回
      </el-button>
      <component :is="partName" :config="partDate" :propData="partProps" />
    </div>
    <!--    对话框-->
    <el-dialog
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      class="ee"
      :before-close="handleDialogClose"
      :title="dialogTitle"
    >
      <div slot="title" v-if="!dialogTitle"></div>
      <component :is="dialogName" :config="dialogDate" :propData="partProps" />
      <div slot="footer" v-if="dialogFooter">
        <!--        <el-button @click="dialogVisible = false">取 消</el-button>-->
        <el-button type="primary" @click="dialogVisible = false">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tableRenderMixin from './tableRenderMixin';

export default {
  mixins: [tableRenderMixin]
};
</script>
<style lang="scss" scoped>
/deep/ .el-tabs__active-bar {
  // display: none !important;
}
/deep/ .el-tabs__nav {
  // border: 2px solid #1989fa !important;
  // border-radius: 8px 8px 0 0;
}
/deep/ .el-tabs__item.is-active {
  // color: #fff;
  // text-align: center;
  // //border-radius: 8px 8px 0 0;
  // background: #1989fa;
}
/deep/ .el-tabs__item {
  padding: 0 20px !important;
  height: 40px;
  line-height: 40px;
}

.hidden-detail {
  float: right;
  width: 1em;
  font-size: 25px;
}
.table-alert {
  border: 1px solid #a3d0fd;
  background: #ebeef5;
}
</style>
